// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Axios from '@/apiConfig/axios'
import VueJsonp from 'vue-jsonp'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from '@/vuex'
import config from '@/apiConfig/index'
import api from '@/apiConfig/api'
import url from '@/utils/url'
import date from '@/utils/date'
import setnull from '@/utils/setnull'
import emq from '@/utils/mqtt'
import area from '@/utils/area'
// import select from '@/utils/select'
import '../static/css/reset.css' // 初始化样式
import './assets/font/iconfont.css' // 阿里icon

Vue.config.productionTip = false

Vue.prototype.$http = Axios // 全局注册，使用方法为:this.$http
Vue.prototype.$api = api // 全局注册，使用方法为:this.$api
Vue.prototype.$url = config.baseURL // 全局注册，使用方法为:this.$url
Vue.prototype.$date1 = date.changeTimeType1 // 全局注册，使用方法为:this.$date1,格式：yyyy-mm-dd 字符串
Vue.prototype.$date2 = date.changeTimeType2 // 全局注册，使用方法为:this.$date2,格式：yyyy-mm-dd hh:ii:ss 字符串
Vue.prototype.$date3 = date.changeTimeType3 // 全局注册，使用方法为:this.$date3,格式：yyyy-mm-dd 时间戳
Vue.prototype.$date4 = date.changeTimeType4 // 全局注册，使用方法为:this.$date4,格式：yyyy-mm-dd hh:ii:ss 时间戳
Vue.prototype.$date5 = date.changeTimeType5 // 全局注册，使用方法为:this.$date5,格式：hh:ii 字符串
Vue.prototype.$date6 = date.changeTimeType6 // 全局注册，使用方法为:this.$date6,格式：hh:ii 时间戳
Vue.prototype.$null = setnull.setnull // 全局注册，使用方法为:this.$null
Vue.prototype.$host = emq.host // 全局注册，使用方法为:this.$host
Vue.prototype.$port = emq.port // 全局注册，使用方法为:this.$port
Vue.prototype.$useSSL = emq.useSSL // 全局注册，使用方法为:this.$useSSL
Vue.prototype.$province = area.province_list // 全局注册，使用方法为:this.$province
Vue.prototype.$city = area.city_list // 全局注册，使用方法为:this.$city
Vue.prototype.$county = area.county_list // 全局注册，使用方法为:this.$county
Vue.prototype.$align = 'center' // 全局注册，使用方法为:this.$align，表格对齐方式
// Vue.prototype.$select = select.select // 全局注册，使用方法为:this.$select
Axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8' // 配置请求头信息
Axios.defaults.baseURL = config.baseURL // 配置公用url
Vue.prototype.$myUrl = url // 全局注册，使用方法为:this.$myUrl，前端自拟数据url

Vue.use(VueJsonp)
Vue.use(ElementUI)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js